import { OneCredentialDelinkTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OneCredentialDelinkTrackingSchema: Record<
  OneCredentialDelinkTrackingPoint,
  string
> = {
  [OneCredentialDelinkTrackingPoint.DelinkInitPageView]: '',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageContinueClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageCancelClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageBackClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageView]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageNextClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageBackClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageView]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageConfirmClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageBackClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageView]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageContinueClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageBackClick]: '',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessAction]: '',
  [OneCredentialDelinkTrackingPoint.DelinkErrorPageView]: '',
};

export const getOneCredentialDelinkInitPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkInitPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};
export const getOneCredentialDelinkSetupTobAccountPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSetupTobAccountPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkSetupPasswordPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSetupPasswordPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkSuccessPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSuccessPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkErrorPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkErrorPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};
